import Button from 'Button';

type Props = {
    color: 'primary' | 'purple';
    onPressCta: () => void;
    ctaText: string;
};

export function ImportantCtaBoxCta({ color, onPressCta, ctaText }: Props) {
    return (
        <div data-id="important-cta-box-cta-container" className="flex justify-center">
            <Button cornerRadius="full" color={color} height={9} onPress={onPressCta}>
                {ctaText}
            </Button>
        </div>
    );
}
